// Moglee Base — cart drawer.
// Adds to cart without a page reload. The drawer draws itself from the live
// cart (/cart.js). Right after an add the cart can briefly still show its old
// contents, so after adding we ask again until the new item shows up.
//
// The line, totals and shipping bar markup built here matches snippets/mb-line-item.liquid,
// snippets/mb-cart-summary.liquid and snippets/mb-shipping-bar.liquid, so keep them in step.

(function () {
  // The cart page and the drawer section both load this file. Only the first
  // copy may run, or every action would happen twice.
  if (window.__mbCartReady) return;
  window.__mbCartReady = true;

  var root = document.documentElement;
  var drawer = document.querySelector('[data-mb-cart-drawer]');
  if (!drawer) return;

  var lastFocus = null;
  var snapshot = null; // the last cart we saw
  var notice = ''; // a message to show once, at the top of the drawer
  var noteDraft = null; // what the customer has typed in the order note, kept when the drawer redraws

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function attr(name) {
    return drawer.getAttribute('data-' + name) || '';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function digits(cents, places, thousands, decimal) {
    var parts = (cents / 100).toFixed(places).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents, withCurrency) {
    var format = attr(withCurrency ? 'money-currency-format' : 'money-format') || '{{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      var places = name.indexOf('no_decimals') === -1 ? 2 : 0;
      return name.indexOf('comma') === -1 ? digits(cents, places, ',', '.') : digits(cents, places, '.', ',');
    });
  }

  // Facts about the add-on products, written into the page by snippets/mb-addons-data.liquid.
  function readAddons(kind) {
    var node = document.querySelector('[data-mb-addons="' + kind + '"]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return [];
    }
  }

  var drawerAddons = readAddons('drawer');

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-mb-cart-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-mb-cart-close]');
    if (close) close.focus();
  }

  function close() {
    root.removeAttribute('data-mb-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-mb-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.classList.toggle('mb-header__count--zero', cart.item_count === 0);
    });
  }

  // Names and amounts of any discounts taken off one line.
  function discountsHtml(item) {
    var list = item.line_level_discount_allocations || [];
    if (!list.length) return '';
    return (
      '<ul class="mb-line__discounts">' +
      list
        .map(function (allocation) {
          var title = allocation.discount_application && allocation.discount_application.title;
          return '<li>' + esc(title) + ' (&minus;' + esc(money(allocation.amount)) + ')</li>';
        })
        .join('') +
      '</ul>'
    );
  }

  // Custom options on a line, such as engraving text or an uploaded file. Names that
  // start with an underscore are hidden by apps on purpose, so they are left out.
  function propertiesHtml(item) {
    var props = item.properties || {};
    var rows = Object.keys(props)
      .filter(function (name) {
        var value = props[name];
        return name.charAt(0) !== '_' && value !== null && value !== undefined && value !== '';
      })
      .map(function (name) {
        var value = String(props[name]);
        var isFile = value.indexOf('/uploads/') !== -1 && (value.indexOf('http') === 0 || value.charAt(0) === '/');
        var shown = isFile
          ? '<a href="' + esc(value) + '">' + esc(value.split('/').pop()) + '</a>'
          : esc(value);
        return '<li><span class="mb-line__prop-name">' + esc(name) + ':</span> ' + shown + '</li>';
      });
    return rows.length ? '<ul class="mb-line__props">' + rows.join('') + '</ul>' : '';
  }

  function lineHtml(item) {
    var picture = item.image || (item.featured_image && item.featured_image.url) || '';
    if (picture) picture += (picture.indexOf('?') === -1 ? '?' : '&') + 'width=240';
    var down = item.quantity - 1;
    var up = item.quantity + 1;
    var key = esc(item.key);
    var discounted = item.original_line_price > item.final_line_price;

    return (
      '<li class="mb-line" data-key="' + key + '">' +
      '<a class="mb-line__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
      (picture ? '<img src="' + esc(picture) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
      '</a>' +
      '<div>' +
      '<p class="mb-line__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
      (item.product_has_only_default_variant || !item.variant_title
        ? ''
        : '<p class="mb-line__meta">' + esc(item.variant_title) + '</p>') +
      (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? '<p class="mb-line__meta">' + esc(item.selling_plan_allocation.selling_plan.name) + '</p>'
        : '') +
      propertiesHtml(item) +
      '<div class="mb-line__row">' +
      '<div class="mb-qty">' +
      '<button type="button" data-mb-qty data-key="' + key + '" data-qty="' + down + '" aria-label="Reduce quantity"' +
      (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" data-mb-qty data-key="' + key + '" data-qty="' + up + '" aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<span class="mb-line__price">' +
      (discounted
        ? '<s class="mb-line__was">' + esc(money(item.original_line_price)) + '</s> <span>' + esc(money(item.final_line_price)) + '</span>'
        : esc(money(item.final_line_price))) +
      '</span>' +
      '</div>' +
      discountsHtml(item) +
      '<button type="button" class="mb-line__remove" data-mb-remove data-key="' + key + '">Remove</button>' +
      '</div>' +
      '</li>'
    );
  }

  // Subtotal, cart-level discounts, total and what the customer saves.
  function summaryHtml(cart) {
    var applications = cart.cart_level_discount_applications || [];
    var html = '<div class="mb-cart-summary" data-mb-summary>';

    if (applications.length) {
      html += '<div class="mb-cart-total"><span>Subtotal</span><span>' + esc(money(cart.items_subtotal_price)) + '</span></div>';
      applications.forEach(function (application) {
        html +=
          '<div class="mb-cart-discount"><span>' + esc(application.title) + '</span><span>&minus;' +
          esc(money(application.total_allocated_amount)) + '</span></div>';
      });
      html += '<div class="mb-cart-total mb-cart-total--final"><span>Total</span><span>' + esc(money(cart.total_price, true)) + '</span></div>';
    } else {
      html += '<div class="mb-cart-total"><span>Subtotal</span><span>' + esc(money(cart.total_price, true)) + '</span></div>';
    }

    if (cart.total_discount > 0) {
      html += '<p class="mb-cart-saved">You save ' + esc(money(cart.total_discount)) + '</p>';
    }

    return html + '</div>';
  }

  // Free shipping progress. Nothing is drawn unless a goal is set in the cart drawer settings.
  function shippingBarHtml(cart) {
    var threshold = parseInt(attr('ship-threshold'), 10) || 0;
    if (!threshold || cart.item_count < 1) return '';
    var left = threshold - cart.total_price;
    var done = left <= 0;
    var percent = Math.min(100, Math.floor((cart.total_price * 100) / threshold));
    var text = done ? attr('ship-success') : attr('ship-progress').replace('[amount]', money(left));
    return (
      '<div class="mb-ship" data-mb-ship data-done="' + done + '">' +
      '<p class="mb-ship__text">' + esc(text) + '</p>' +
      '<div class="mb-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + percent + '">' +
      '<span style="width: ' + percent + '%"></span></div>' +
      '</div>'
    );
  }

  // Offers from the add-ons collection, leaving out anything already in the bag.
  function addonsHtml(cart, list, heading, limit) {
    if (!list || !list.length || cart.item_count < 1) return '';

    var inBag = {};
    cart.items.forEach(function (item) {
      inBag[item.product_id] = true;
    });

    var offers = list
      .filter(function (product) {
        return product.available && !inBag[product.id];
      })
      .slice(0, limit || 3);
    if (!offers.length) return '';

    return (
      '<div class="mb-addons"><h3 class="mb-addons__title">' + esc(heading) + '</h3><ul class="mb-addons__list">' +
      offers
        .map(function (product) {
          return (
            '<li class="mb-addon">' +
            (product.image
              ? '<a class="mb-addon__media" href="' + esc(product.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(product.image) + '" alt="" loading="lazy"></a>'
              : '<span></span>') +
            '<div class="mb-addon__info"><a class="mb-addon__title" href="' + esc(product.url) + '">' + esc(product.title) + '</a>' +
            '<span class="mb-addon__price">' + esc(product.price) + '</span></div>' +
            (product.single
              ? '<button type="button" class="mb-addon__add" data-mb-addon="' + product.variant + '">Add</button>'
              : '<a class="mb-addon__add" href="' + esc(product.url) + '">Choose</a>') +
            '</li>'
          );
        })
        .join('') +
      '</ul></div>'
    );
  }

  // The cart page draws its offers into a slot once it knows what is in the bag.
  function fillPageAddons(cart) {
    var slot = document.querySelector('[data-mb-addons-slot]');
    if (!slot) return;
    slot.innerHTML = addonsHtml(
      cart,
      readAddons('page'),
      slot.getAttribute('data-heading'),
      parseInt(slot.getAttribute('data-limit'), 10)
    );
  }

  // The order note box, when the section's setting turns it on. It sits inside the
  // checkout form, so whatever is typed goes with the order.
  function noteHtml(cart) {
    if (attr('show-note') !== 'true') return '';
    var value = noteDraft !== null ? noteDraft : cart.note || '';
    return (
      '<label class="mb-note"><span class="mb-note__label">Order note</span>' +
      '<textarea name="note" rows="3" data-mb-note>' + esc(value) + '</textarea></label>'
    );
  }

  // Shopify's express checkout buttons are not ours to rebuild, so they are lifted
  // out before the drawer redraws and put back in the new checkout form.
  function restoreExpress(express) {
    if (!express) return;
    var form = drawer.querySelector('[data-mb-checkout-form]');
    if (!form) {
      // Empty bag: keep the buttons out of sight until there is something to buy.
      form = document.createElement('form');
      form.action = attr('cart-url');
      form.method = 'post';
      form.hidden = true;
      drawer.appendChild(form);
    }
    form.appendChild(express);
  }

  function render(cart) {
    snapshot = cart;
    var express = drawer.querySelector('[data-mb-express]');
    var html =
      '<div class="mb-cart-drawer__head">' +
      '<h2 class="mb-cart-drawer__title">' + esc(attr('heading')) + ' (' + cart.item_count + ')</h2>' +
      '<button type="button" class="mb-cart-drawer__close" data-mb-cart-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="mb-cart-drawer__body">' +
      (notice ? '<p class="mb-cart-error" role="alert">' + esc(notice) + '</p>' : '') +
      shippingBarHtml(cart);
    notice = '';

    if (cart.item_count > 0) {
      html +=
        '<ul class="mb-line-items">' + cart.items.map(lineHtml).join('') + '</ul>' +
        addonsHtml(cart, drawerAddons, attr('addons-heading'), parseInt(attr('addons-limit'), 10)) +
        '</div>';
      html +=
        '<div class="mb-cart-drawer__foot">' +
        summaryHtml(cart) +
        (attr('note') ? '<p class="mb-cart-note">' + esc(attr('note')) + '</p>' : '') +
        '<form action="' + esc(attr('cart-url')) + '" method="post" data-mb-checkout-form>' +
        noteHtml(cart) +
        '<button type="submit" name="checkout" class="mb-checkout">' + esc(attr('checkout-label')) + '</button>' +
        '</form>' +
        '<a class="mb-cart-link" href="' + esc(attr('cart-url')) + '">View cart</a>' +
        '</div>';
    } else {
      html +=
        '<div class="mb-cart-empty"><p>' + esc(attr('empty-text')) + '</p>' +
        '<p><a class="mb-cart-link" href="' + esc(attr('all-url')) + '">Continue shopping</a></p></div></div>';
    }

    drawer.innerHTML = html;
    restoreExpress(express);
    updateCount(cart);
  }

  // Reads the cart fresh, never from the browser cache.
  function getCart() {
    return fetch(routeRoot() + 'cart.js?t=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        snapshot = cart;
        return cart;
      });
  }

  // After an add, keeps asking until the cart holds at least minCount items
  // (about four seconds at most), then returns the freshest cart it saw.
  function settle(minCount) {
    var tries = 0;

    function attempt() {
      return getCart().then(function (cart) {
        if (cart.item_count >= minCount) return cart;
        if (tries >= 12) {
          setTimeout(function () {
            getCart().then(render).catch(function () {});
          }, 2500);
          return cart;
        }
        tries += 1;
        return new Promise(function (resolve) {
          setTimeout(resolve, 350);
        }).then(attempt);
      });
    }

    return attempt();
  }

  function refresh(minCount) {
    return (minCount ? settle(minCount) : getCart()).then(render).catch(function (error) {
      console.error('[Moglee cart] could not refresh the drawer', error);
    });
  }

  // Add to cart from any product form.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    var data = new FormData(form);
    var quantity = parseInt(data.get('quantity'), 10) || 1;
    var wanted = 0;

    getCart()
      .catch(function () {
        return { item_count: snapshot ? snapshot.item_count : 0 };
      })
      .then(function (before) {
        wanted = before.item_count + quantity;
        return fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        });
      })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function () {
        return refresh(wanted);
      })
      .then(open)
      .catch(function (error) {
        console.error('[Moglee cart] add to bag failed', error);
        if (error && error.description) {
          window.alert(error.description);
        } else {
          form.submit();
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = label;
        }
      });
  });

  // Quick add sheet (assets/mb-quickadd.js): note the cart when the sheet is
  // ready, and once an item has been added wait for it, then show the drawer.
  document.addEventListener('mb:qa:ready', function (event) {
    var sheet = event.detail;
    new MutationObserver(function () {
      var state = sheet.wrap.getAttribute('data-state');
      if (state === 'ready') {
        getCart().catch(function () {});
        return;
      }
      if (state !== 'added') return;
      var wanted = (snapshot ? snapshot.item_count : 0) + 1;
      refresh(wanted).then(function () {
        sheet.close();
        open();
      });
    }).observe(sheet.wrap, { attributes: true, attributeFilter: ['data-state'] });
  });

  // Shows or clears a message above the line items on the cart page.
  function pageError(message) {
    var box = document.querySelector('[data-mb-cart-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  // One tap on an add-on offer: adds it, then refreshes the bag.
  function addAddon(button) {
    var id = parseInt(button.getAttribute('data-mb-addon'), 10);
    if (!id || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function () {
        if (document.querySelector('[data-mb-cart-page]')) {
          window.location.reload();
          return null;
        }
        return refresh((snapshot ? snapshot.item_count : 0) + 1);
      })
      .catch(function (error) {
        var message = (error && (error.description || error.message)) || 'That item could not be added.';
        notice = message;
        pageError(message);
        button.disabled = false;
        button.textContent = 'Add';
        return getCart().then(render);
      });
  }

  // Quantity changes and removals inside the drawer or on the cart page.
  function change(key, quantity) {
    var container = document.querySelector('[data-mb-cart-open] [data-mb-cart-drawer]') || drawer;
    container.setAttribute('aria-busy', 'true');
    pageError('');

    fetch(routeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        var body = result.body;

        // Shopify refuses a change it cannot make, for example more than the
        // stock on hand. The reply is an error, not a cart, so keep the cart
        // as it was, say why, and never draw the error as if it were the cart.
        if (!result.ok || !body || !Array.isArray(body.items)) {
          var message = (body && (body.description || body.message)) || 'That change could not be made.';
          notice = message;
          pageError(message);
          return getCart().then(render);
        }

        render(body);
        if (document.querySelector('[data-mb-cart-page]')) window.location.reload();
      })
      .catch(function (error) {
        console.error('[Moglee cart] could not change the cart', error);
        window.location.reload();
      })
      .finally(function () {
        container.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mb-cart-toggle]');
    if (opener) {
      event.preventDefault();
      open();
      refresh();
      return;
    }

    if (event.target.closest('[data-mb-cart-close]') || event.target.closest('[data-mb-cart-overlay]')) {
      event.preventDefault();
      close();
      return;
    }

    var step = event.target.closest('[data-mb-qty]');
    if (step) {
      event.preventDefault();
      change(step.getAttribute('data-key'), parseInt(step.getAttribute('data-qty'), 10));
      return;
    }

    var remove = event.target.closest('[data-mb-remove]');
    if (remove) {
      event.preventDefault();
      change(remove.getAttribute('data-key'), 0);
      return;
    }

    var addon = event.target.closest('[data-mb-addon]');
    if (addon) {
      event.preventDefault();
      addAddon(addon);
    }
  });

  // Order note: remember what is typed so a redraw does not wipe it, and save it to
  // the cart when the customer leaves the box. It also goes with the checkout form.
  document.addEventListener('input', function (event) {
    if (event.target.matches && event.target.matches('[data-mb-note]')) {
      noteDraft = event.target.value;
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-mb-note]')) return;
    noteDraft = event.target.value;

    fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: noteDraft })
    }).catch(function (error) {
      console.error('[Moglee cart] could not save the order note', error);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.getAttribute('data-mb-cart-open') === 'true') close();
  });

  // Coming back to the page from the browser cache: make sure the drawer is current.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  // Note what is in the cart as soon as the page loads, and fill the cart page's offers.
  getCart().then(fillPageAddons).catch(function () {});
})();
